import React from 'react';
import { Controller, useForm } from 'react-hook-form';
import { Multiselect } from 'react-widgets';
import ErrorMessage from '../../../../components/text/ErrorMessage';
import {
  AppPermissions,
  Checklist,
  convertPascalCaseToWords,
  useHasPermission,
  VehicleStatus,
} from '../../../../core';
const CreateForm: React.FunctionComponent<{
  onSubmit: (data: Checklist) => void;
  onCancel: () => void;
  isSubmitting?: boolean;
  data?: Checklist;
  error?: string;
  onDelete: (id?: string) => void;
}> = (props) => {
  const { control, handleSubmit, errors } = useForm<Checklist>({
    reValidateMode: 'onChange',
    mode: 'onSubmit',
  });
  const [isDeleteModalOpen, setDeleteModalOpen] = React.useState<boolean>(
    false
  );
  const onDelete = () => {
    setDeleteModalOpen(true);
  };
  const onCancelDelete = () => {
    setDeleteModalOpen(false);
  };
  const renderDeleteConfirm = () => {
    return isDeleteModalOpen ? (
      <>
        <div
          className="modal fade show in"
          id="exampleModal"
          aria-labelledby="exampleModalLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog modal-dialog-confirm modal-dialog-centered">
            <div className="modal-content rounded-0">
              <div className="modal-body text-center">
                <div className="container">
                  <div className="row">
                    <div className="col">
                      <p>
                        You are about to delete the Check List with name{' '}
                        {props.data?.name}
                      </p>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-auto mr-auto">
                      <button
                        type="button"
                        className="btn btn-outline-dark py-2 font-weight-semibold font-normal px-4 mr-1"
                        onClick={onCancelDelete}
                      >
                        Cancel
                      </button>
                    </div>
                    <div className="col-auto">
                      <button
                        type="button"
                        className="btn btn-primary py-2 font-weight-semibold font-normal px-4 "
                        onClick={() => props.onDelete(props.data?._id)}
                      >
                        Delete
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="modal-backdrop fade show"></div>
      </>
    ) : (
      <></>
    );
  };
  const renderEnglishTextBox = () => {
    return (
      <div className="col-lg-12 col-12">
        <div className="form-group font-weight-semibold mb-3">
          <label className="font-sm text-uppercase">Item </label>
          <Controller
            control={control}
            rules={{
              required: 'Item is required',
              validate: (value) => {
                return !!value.trim() || 'Item  is required';
              },
            }}
            name="name"
            defaultValue={props.data?.name}
            render={({ onChange, value, name }) => (
              <input
                type="text"
                className="form-control rounded-sm font-weight-semibold"
                placeholder="Item"
                name={name}
                value={value}
                onChange={onChange}
                id="name"
              />
            )}
          />
          <ErrorMessage>{errors.name?.message}</ErrorMessage>
        </div>
      </div>
    );
  };

  const renderVehicleStatus = () => {
    return (
      <div className="col-lg-12 col-12">
        <div className="form-group font-weight-semibold mb-3">
          <label className="font-sm text-uppercase">Vehicle Status </label>
          <Controller
            control={control}
            rules={{
              required: 'Vehicle Status is required',
            }}
            name="vehicleStatus"
            defaultValue={props.data?.vehicleStatus}
            render={({ onChange, value, name }) => (
              <Multiselect
                value={value}
                data={Object.keys(VehicleStatus).map((status) => ({
                  status: (VehicleStatus as any)[status],
                }))}
                textField="status"
                valueField="status"
                defaultValue={value}
                placeholder={'Select Vehicle Status'}
                onChange={(val) => {
                  onChange(val?.map((x) => x.status));
                }}
                allowCreate="onFilter"
                autoFocus={true}
              />
            )}
          />
          {errors.vehicleStatus && (
            <ErrorMessage>Vehicle Status is required</ErrorMessage>
          )}
        </div>
      </div>
    );
  };
  const renderButton = () => {
    return (
      <div className="col-12">
        <div className="form-group font-weight-semibold mb-3 text-right pt-3">
          {props.data?._id && (
            <button
              type="button"
              className="btn btn-outline-gray py-2 font-weight-semibold font-normal px-4 mr-1"
              onClick={onDelete}
            >
              <i className="icon-bin-fill cursor-pointer align-self-center font-lg text-gray-700"></i>
            </button>
          )}
          <button
            type="button"
            className="btn btn-outline-dark py-2 font-weight-semibold font-normal px-4 mr-1"
            onClick={props.onCancel}
          >
            Cancel
          </button>
          <button
            type="submit"
            className="btn btn-primary py-2 font-weight-semibold font-normal px-4 "
            disabled={props.isSubmitting}
          >
            {!props.data?._id ? 'Create' : 'Update'}
          </button>
        </div>
      </div>
    );
  };
  return (
    <form onSubmit={handleSubmit(props.onSubmit)}>
      <div className="p-4">
        <h4 className="mb-3 font-weight-semibold">
          Vehicle Availability Check List
        </h4>
        <div className="row gutter-10">
          {renderEnglishTextBox()}
          {renderVehicleStatus()}
          <ErrorMessage>{props.error}</ErrorMessage>
          {renderButton()}
          {renderDeleteConfirm()}
        </div>
      </div>
    </form>
  );
};
export default CreateForm;
